import i18next from 'i18next';
import { AppProps } from '../../@types/AppProps';
import ButtonAlt from '../../Components/Button/ButtonAlt';
import HtmlNode from '../../Components/Extension/HtmlNode';
import WhatHappensNow from './WhatHappensNow';

const BUTTON_CLOSE_NODE = 'button-close-node';

interface SummaryProps {
  state: {
    fname: string;
  };
  settings: AppProps;
  onClose: () => void;
}

class Summary extends HtmlNode {
  private readonly props: SummaryProps;

  constructor(element: HTMLElement, props: SummaryProps) {
    super(element);
    this.props = props;
    this.render();
  }

  render() {
    this.node.innerHTML = `
      <div class="waykevaluation-stack waykevaluation-stack--4">
        <div class="waykevaluation-stack waykevaluation-stack--3" aria-hidden="true">
          <div class="waykevaluation-align waykevaluation-align--center">
            <div class="waykevaluation-icon-backdrop waykevaluation-icon-backdrop--large waykevaluation-icon-backdrop--success">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                class="waykevaluation-icon"
                data-icon="Check"
              >
                <path
                  d="M12.3 3.3 6 9.6 3.7 7.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3 3c.4.4 1 .4 1.4 0l7-7c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="waykevaluation-stack waykevaluation-stack--3">
          <h3 class="waykevaluation-heading waykevaluation-heading--3 waykevaluation-no-margin">
            ${i18next.t('summary.thankYouMessage', { name: this.props.state.fname })}
          </h3>
        </div>
      </div>
      ${WhatHappensNow()}
      <div class="waykevaluation-stack waykevaluation-stack--4" id="${BUTTON_CLOSE_NODE}"></div>
    `;
    new ButtonAlt(document.querySelector<HTMLDivElement>(`#${BUTTON_CLOSE_NODE}`), {
      title: i18next.t('summary.closeButtonText'),
      onClick: () => this.props.onClose(),
    });
  }
}

export default Summary;
